import Resource from '@/api/resource';

class TrustedCompanyResource extends Resource {
  constructor() {
    super('admin/trusted-companies');
  }
}

export { TrustedCompanyResource as default };
